import { Form, Row, Col } from "reactstrap"
import FormInput from "../../common/FormInput"
import { safeNumberToString } from '../../../utils/productDataMappers';
import { useFormSection } from 'features/products/context/ProductDetailContext';

const ReplenishmentProfile: React.FC = () => {
  const { watch, setValue, getError } = useFormSection('replenishment');
  
  return (
    <fieldset className="border rounded p-2">
      <legend className="float-none w-auto px-2 mb-0 text-body" style={{ fontSize: '0.9rem' }}>Replenishment Profile</legend>
      <Form>
        <Row>
          <Col md={4}>
            <FormInput
              id="waterLevel"
              label="Order Point"
              value={safeNumberToString(watch('waterLevel'))}
              onChange={(value: string) => setValue('waterLevel', value)}
              type="number"
            />
            {/* Display validation error if any */}
            {getError('waterLevel') && (
              <div className="text-danger small mt-1">
                {getError('waterLevel')?.message}
              </div>
            )}
          </Col>
          <Col md={4}>
            <FormInput
              id="reorderQuantity"
              label="Reorder Qty"
              value={safeNumberToString(watch('reorderQuantity'))}
              onChange={(value: string) => setValue('reorderQuantity', value)}
              type="number"
            />
            {/* Display validation error if any */}
            {getError('reorderQuantity') && (
              <div className="text-danger small mt-1">
                {getError('reorderQuantity')?.message}
              </div>
            )}
          </Col>
          <Col md={4}>
            <FormInput
              id="orderQtyMultiple"
              label="Qty Multiple"
              value={safeNumberToString(watch('orderQtyMultiple'))}
              onChange={(value: string) => setValue('orderQtyMultiple', value)}
              type="number"
            />
            {/* Display validation error if any */}
            {getError('orderQtyMultiple') && (
              <div className="text-danger small mt-1">
                {getError('orderQtyMultiple')?.message}
              </div>
            )}
          </Col>
        </Row>
      </Form>
    </fieldset>
  )
}

export default ReplenishmentProfile